<mat-form-field>
  <mat-select
    class="school-level-select"
    [(ngModel)]="selectedSchoolLevel"
    (selectionChange)="schoolLevelSelected.emit($event)"
  >
    <mat-option
      *ngFor="let schoolLevel of schoolLevels"
      [value]="schoolLevel"
      >{{ schoolLevel }}</mat-option
    >
  </mat-select>
</mat-form-field>
